import React from 'react';
import { ReactNode } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';



// ************************************ HOME PAGE ************************
// import   HomePage_v01    from '../component-library/HomePage_v01_Component';

import  HomePage_LegacyInsurance    from '../Insurance-Legacy/HomePage_v02_TwoRows_LegacyInsurance';
import { AppConfig_DATA  } from "./App_v01_DiscountPaintersInsurance_ConfigData";
// ************************************ HOME PAGE ************************


//import NavBar_v03Responsive from '../component-library/NavBar_v03a_Responsive_component';
import NavBar_v03Responsive_DISCOUNT_PAINTERS from './App_v01_DiscountPainters_NavBar_v03a_Responsive_component';

import Footer from "../component-library/Footer_v01a_component";

import About_v01 from '../component-library/AboutUs_Page_v01-component';
import Services_v01 from '../component-demos/stash/Services_v01';
// import Contact_v01 from '../component-library/ContactUs_Page_v01_component';





//  CUSTOM SECTION - NEEDED TO ADD ATRIUM NAME ON THE PAGE 
import Contact_LegacyInsurance_v01 from '../Insurance-Legacy/StandardPages/ContactUs_Page_LegacyInsurance_v01';





import TestPage_v01 from '../sundance-vending/components/TestPage_v01';
import TestCreditCardComponent from '../component-library/CreditCardComponent_v01_test'
import CreditCardManager from '../ScoreCards/SmartMoneyCredit/CreditManager/CreditCardManager_v01'
import FAQs_Page_v01_MASTER_WithSUB from '../component-library/MASTER-COMPONENTS/FAQ_Page_v01_MASTER_WithSUB';
import LeftSideNavScrollSpy_v03 from '../component-demos/LeftSideNavBarScorllSpy_v03';



//LEGAL & SECURITY 
import { ContactFormWithCaptcha_TEST } from '../component-library/reactCA';
import TermsOfServiceLegacyInsurance from '../Insurance-Legacy/StandardPages/LEGAL_TOS_LegacyInsurance_v01';
import PrivacyPolicy from '../Insurance-Legacy/StandardPages/LEGAL_PrivacyPolicy_LegacyInsurance_v01';


import BizServicesListImagesMultiColumn_v03 from "../component-library/BizServicesListImagesMultiColumn_v03";

import ChatBot from "../component-library/ChatBOT_v01_component";

import AboutLegacyInsurance from '../Insurance-Legacy/StandardPages/AboutLegacyInsurance_Page_v01';
import AboutLegacyInsurance_v02 from '../Insurance-Legacy/StandardPages/AboutLegacyInsurance_Page_v02a';
import AboutLegacyInsurance_v03 from '../Insurance-Legacy/StandardPages/AboutLegacyInsurance_Page_v03';

import CardListDemoPage from '../component-demos/CardAndListDemo_Page_v01';

// import  WindowScoreCardQuiz   from "../Windows/WindowsQuiz_v01";

// import BossScoreCard from "../ScoreCards/hostingScoreCard.com/BossScoreCard/BossScoreCard-component";

import DISCOUNT_PAINTERS_LandingPage_v01_WIZARD from '../component-demos/PAINTERS-INSURANCE/DISCOUNT_PAINTERS_LandingPage_v01_WIZARD_CHAT_2025_11_25';


// import InsuranceExample from '../Insurance-Legacy/stash/Examples-component_v01';
// import InsuranceExample2 from '../Insurance-Legacy/stash/Examples-component_v02';
// import InsuranceExample3 from '../Insurance-Legacy/InsuranceExamples-component_v03';

// import FamilyInsuranceScoreCard from '../Insurance-Legacy/scoreCardComponents/FamilyInsuranceScoreCard_v01';
// import BusinessInsuranceScoreCard from '../Insurance-Legacy/scoreCardComponents/BusinessIsuranceScoreCard_v01';

// import CustomEdgeFabricationLanding from '../Custom-Edge-Fabrication/HomePage_v01-CustomEdge';

// import InsuranceLookup from './InsuranceLookup-component';
// import InsuranceLookup_v02 from './InsuranceLookup-component_v02';

// import InsuranceLookup_v03  from './InsuranceLookup-component_v03-cardAndExample';
// import InsuranceLookup_v04 from './InsuranceLookup-component_v04-cardAndExample';
// import InsuranceLookup_v05 from './InsuranceLookup-component_v05-cardAndExample'


// import BrokerBenefits_v01 from './BrokerBenefits_v01';
// import BrokerBenefits_v02 from './BrokerBenefits_v02';
// import BorkerBenefits_v03 from './BrokerBenefits_v03';

// import  InsuranceQuoteForm from "./QuoteForms/RequestAQuote_v01";

// import { InsuranceQuoteForm_Gemini_v01 } from "./QuoteForm-Gemini/QuoteForm-Gemini";


// import { DUI_QuoteWizard_v01g  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01g";
// import { ExampleDuiQuoteWizard_H7  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01H7";
// import { ExampleDuiQuoteWizard_H8  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01H8";






// //import { ExampleDuiQuoteWizard_H8  } from "../DUIInsurance/dui-wizard/";
// import { ExampleQuoteWizard_H9  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_AutoInsurance_wizard_v01H9";
// import { AutoDUI_QuoteWizard_H10  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_InsuranceQuote_wizard_v01H10";
// import { AutoDUI_QuoteWizard_H11a  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_InsuranceQuote_wizard_v01H11a";


// import { EasyDuiLandingPage_v01  } from "../component-demos/DUI-Insurance/DUILandingPage_v01";
// import { EASY_DUI_LandingPage_v02 } from "../component-demos/DUI-Insurance/DUILandingPage_v02";
// import { EASY_DUI_LandingPage_v02a } from "../component-demos/DUI-Insurance/DUILandingPage_v02a";

// import { EASY_DUI_LandingPage_v02b } from "../component-demos/DUI-Insurance/DUILandingPage_v02b";
// import { EASY_DUI_LandingPage_v02c } from "../component-demos/DUI-Insurance/DUILandingPage_v02c";
// import { EASY_DUI_LandingPage_v02c_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02c_WIZARD";
// import { EASY_DUI_LandingPage_v02d_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02d_WIZARD";
// import { EASY_DUI_LandingPage_v02e_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02e_WIZARD";
// import { EASY_DUI_LandingPage_v02f_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02f_WIZARD";
// import { EASY_DUI_LandingPage_v02g_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02g_WIZARD";
// import { EASY_DUI_LandingPage_v02h_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02h_WIZARD";

// import { EASY_DUI_LandingPage_v02K_WIZARD } from "../EasyDUI-Insurance/DUILandingPage_v02k_WIZARD";

// import { DISCOUNT_CONTRACTOR_LandingPage_v02K_WIZARD } from "../component-demos/DUI-Insurance/EasyContractorInsurance_LandingPage_v02k_WIZARD";
// import { HotTubQuiz_Landing_v01  } from "../component-demos/DUI-Insurance/HotTub-Quiz_v01";



// import { EASY_RENTERS_LandingPage_v01_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02h_WIZARD";
// import { EASY_RENTERS_LandingPage_v02i_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02i_WIZARD";
// import { EASY_RENTERS_LandingPage_v02j_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02j_WIZARD";
// import { EASY_RENTERS_LandingPage_v02k_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02k_WIZARD";
// import { EASY_RENTERS_LandingPage_v02L_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02L_WIZARD";
// import { EASY_RENTERS_LandingPage_v02M_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02M_WIZARD";
// import { EASY_RENTERS_LandingPage_v02N_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02N_WIZARD";
// import { EASY_RENTERS_LandingPage_v02O_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02O_WIZARD";
// import { EASY_RENTERS_LandingPage_v02P_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02P_WIZARD";
// import { EASY_RENTERS_LandingPage_v02O_01_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02O_01_WIZARD";



// import { DISCOUNT_WELDING_LandingPage_v020_WIZARD }   from "../component-demos/DUI-Insurance/WeldingInsur_LandingPage_v02O_WIZARD";
// import { DISCOUNT_WELDING_LandingPage_v020b_WIZARD }   from "../component-demos/DUI-Insurance/WeldingInsur_LandingPage_v02Ob_WIZARD";


// import { EASY_PAINTING_LandingPage_v02O_WIZARD }      from "../component-demos/DUI-Insurance/PAINTER_Insur_LandingPage_v02O_WIZARD";
// import { DISCOUNT_JEWELRY_Landing_v020_WIZARD }       from "../component-demos/DUI-Insurance/JEWELRY_LandingPage_v02O_WIZARD";
// import { DISCOUNT_PLUMBERS_LandingPage_v02O_WIZARD }  from "../component-demos/DUI-Insurance/PlumbersInsur_LandingPage_v02O_WIZARD";

// import { CERTIFIED_SOLAR_REPORT_Landing_v02O_WIZARD }  from "../component-demos/DUI-Insurance/SOLAR-home-report_LandingPage_v02O_WIZARD";


// import { DENVER_ParkingLotStriping_Landing_v01_WIZARD }  from "../component-demos/DUI-Insurance/ParkingLotStripe_LandingPage_v02O_WIZARD";
// import { EASY_CONTRACTOR_LandingPage_v02O_WIZARD }  from "../component-demos/DUI-Insurance/EasyContractorsInsurance_LandingPage_v02O_WIZARD";












import { DUIInsurance_Benefits_v01 } from "../component-demos/DUI-Insurance/DUI_Benefits_v01";






import { RestaurantFeedbackWizard_H11aStyled } from "../component-demos/BUSINESS-FEEDBACK-FORMS/Restaurant-feedback-v01a";

import { AutoShopFeedbackWizard_H11bStyled } from "../component-demos/BUSINESS-FEEDBACK-FORMS/AutoShop-feedback-v01a";




// import { ExampleContractorWizard_C1  } from "./QuoteForms/ContractorQuoteForm_v01a";

// import { ExampleContractorWizard_C2  } from "../component-demos/INSURANCE-FORMS/Contractor-work-comp_v01";


// import { ExamplePaintingWizard_P1  } from "../component-demos/INSURANCE-FORMS/Contractor-painting_v01";
// import { PaintingContractorInsuranceLanding } from "../component-demos/INSURANCE-FORMS/PaintingContractor-landingPage";

// import { Motorcycle_QuoteWizard_H2a } from "./QuoteForms/MotorCycle-Insurnace-Quote_v01a";

// import { Contractor_QuoteWizard_H2 } from "./QuoteForms/Contractor-Insurance-Quote_v01";


// import { Contractor_QuoteWizard_H2_A } from "./QuoteForms/Contractor-v2-demos/Contractor-insurance-quote-v01A-example";
// import { Contractor_QuoteWizard_H2_B } from "./QuoteForms/Contractor-v2-demos/Contractor-insurance-quote-v01B-example";

// import { Renters_QuoteWizard_H2 } from "./QuoteForms/Renters-Insurance/Renter-Insurance_v01";
// import { Renters_Insurance_v02 } from "./QuoteForms/Renters-Insurance/Renters-Insurance_v02";
// import { Renters_Insurance_v03 } from "./QuoteForms/Renters-Insurance/Renters-Insurance_v03";
// import { RentersInsuranceLandingPage_v01  } from "./QuoteForms/Renters-Insurance/Renters-Insurance-LandingPage_v01";







import  USMapInteractive   from "../component-demos/US-MAP-DEMOS/US-Map-demo_v01";
import  DualViewWizard_Vending_H2  from "../component-demos/Vending/Vending-quote-v01";
import {VendingInterest_v03} from "../component-demos/Vending/Vending-CustomerInterest-v03"

import DenverSalesforceLandingPage_v01 from "../component-demos/SalesForce-demo/DenverSalesForceLandingPage_v01"


import { EasyButtonInsuranceLandingPage_v01 } from "../component-demos/EASY-BUTTON-INSURANCE/EasyButtonInsuranceLandingPage_v01";

import  SOLAR_5280_LandingPage_v01   from "../component-demos/SOLAR-DEMOS/Solar_5280_LandingPage_v01";




// PET 
import { DollarPetInsuranceLanding_v02 } from "../component-demos/PET-INSURANCE/PetInsurance_v02";

import { PetInsuranceLanding_v03_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v03_Carousel";
import { PetInsuranceLanding_v03a_Carousel }  from "../component-demos/PET-INSURANCE/PetInsurance_v03a_Carousel";
import { PetInsuranceLanding_v04_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v04_Carousel";
import { PetInsuranceLanding_v05_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v05_Carousel";


import { PET_Insurance_TOPICS_Page_Example_v01  } from "../component-demos/PET-INSURANCE/BENEFTIS-COMPONENT/PET-Insurance-topic-example-page_v01";


//DUI
import { DUI_InsuranceLanding_v04_Carousel } from "../component-demos/PET-INSURANCE/DUI_Insurance_v04_Carousel";

import  DUIInsuranceLandingPage_v05  from "../component-demos/DUI-Insurance/DUILandingPage_v05_Carousel";



import { SecretShopperTeamLanding_v01 } from "../component-demos/SECRET-Shopper/SecretShopperLandingPage";


// import { DUIInsuranceDocView_v01  } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/DUIInsuranceInfoView_v01";

// import {  } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_INSURANCE_INFO_DISPLAY_v01";
import { hvacInsurance } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_HVAC_Insurance_v01";


import InsuranceCard_v01 from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_INSURANCE_INFO_DISPLAY_v01"
// import InsuranceCard from "../components/InsuranceCard";

import { ReactFourTabs_v01 } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v01";


import { React_Tabs_v01_NavHeaderFooter } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v02-NavHeaderFooter";
import { TabsWithLeftOffcanvas_v03 } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v03-NavHeaderFooter";

import { TabsWithLeftOffcanvas_v04  } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v04-NavHeaderFooter";

import { PowerWashLandingCarousel_v01  } from "../component-demos/POWERWASH-SERVICE-BIZ/PowerWashLanding_v01";
import { PowerWashingLanding_v05_Carousel } from "../component-demos/POWERWASH-SERVICE-BIZ/PowerWashingLanding_v05_carousel";


import { TAX_DeepDive_Landing_v05_Carousel } from "../component-demos/TAX-DEEP-DIVE/TaxDeepDive_v01";
import { TAX_DEEP_DIVE_LandingPage_v02O } from "../component-demos/TAX-DEEP-DIVE/TAX_DEEP_DIVE_LandingPage_v02O";


// 

import { IAppConfig } from "../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}

//import IBusinessServicesDataProps from "../component-library/BizServicesListImagesMultiColumn_v03";


const AppRouts_v01: React.FC = () => {

  return (
    <Router>
            <div className="d-flex flex-column min-vh-100 justify-content: flex-start">
              <NavBar_v03Responsive_DISCOUNT_PAINTERS appConfig={AppConfig_DATA} />
                <main className="flex-fillx">
                  <Routes>
                      

                      {/* src/component-demos/DUI-Insurance/EasyTrashOut_LandingPage_v02O_01_WIZARD_gemini_2025_10_22.tsx */}
                      <Route path="/" element={<DISCOUNT_PAINTERS_LandingPage_v01_WIZARD />} />
                      <Route path="*" element={<DISCOUNT_PAINTERS_LandingPage_v01_WIZARD />} />



                      
                      <Route path="/home" element={<HomePage_LegacyInsurance appConfig={AppConfig_DATA} />} />
                      
                      {/* 
                      <Route path="*" element={<HomePage_LegacyInsurance appConfig={AppConfig_DATA} />} />
                      */}
                      
                      <Route path="/faq" element={<FAQs_Page_v01_MASTER_WithSUB  faqDataDocument={AppConfig_DATA.faqData} />} />
                      {/* <Route path="/about" element={<About_v01    appConfig={AppConfig_DATA} />} /> */}
                      <Route path="/about" element={<AboutLegacyInsurance_v03 />} />

                      <Route path="/contact" element={<Contact_LegacyInsurance_v01 appConfig={AppConfig_DATA} />} />
                      
                      <Route path="/businessInsurance" element={<BizServicesListImagesMultiColumn_v03 bizServicesData={AppConfig_DATA.ServicesPage1} />} />
                      <Route path="/personalInsurance" element={<BizServicesListImagesMultiColumn_v03 bizServicesData={AppConfig_DATA.ServicesPage2} />} />
                      <Route path="/tos" element={<TermsOfServiceLegacyInsurance />} />
                      <Route path="/privacy" element={<PrivacyPolicy />} />
                      

                     
                      
                  </Routes>
                </main>
                <Footer appConfig={AppConfig_DATA}/>
              </div>
    </Router>
  );
};






export default AppRouts_v01;
